import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export const trackHintQuestionBannerShow = (offer: TOffer | undefined) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MortgageDiscount',
    action: 'Show_sopr',
    label: 'Banner',
    products: offer ? getProducts([offer]) : /* istanbul ignore next */ [],
  });
};

export const trackHintQuestionBannerButtonClick = (offer: TOffer | undefined, buttonName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MortgageDiscount',
    action: 'Click',
    label: 'Banner',
    products: offer ? getProducts([offer]) : /* istanbul ignore next */ [],
    page: {
      extra: {
        buttonName,
      },
    },
  });
};
